const estimatedClosingCosts = {
  id: "estimatedClosingCosts",
  label: "Estimated Closing Costs",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const downPayment = {
  id: "downPayment",
  label: "Down Payment",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const originationFee = {
  id: "originationFee",
  label: "Origination Fee",
  isVisible: (role: string) => role !== 'loanOfficer',
  isEditable: () => true,
  isCurrency: true
};

const taxesAndInsuranceReserves = {
  id: "taxesAndInsuranceReserves",
  label: "Taxes and Insurance Reserves",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const closingFee = {
  id: "closingFee",
  label: "Closing Fee",
  isVisible: () => true,
  isEditable: () => true,
  isCurrency: true
};

const underWritingFee = {
  id: "underwritingfee",
  label: "Underwriting Fee",
  isVisible: () => true,
  isEditable: () => true,
  isCurrency: true
};

const totalEstimatedClosingCosts = {
  id: "totalEstimatedClosingCosts",
  label: "Total Estimated Closing Costs",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const appraisalFee = {
  id: "appraisalFee",
  label: "Appraisal/Appraisal Review Fee",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const interestReserves = {
  id: "interestReserves",
  label: "Interest Reserves",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true
};

const outOfPocketRehabCosts = {
  id: "outOfPocketRehabCosts",
  label: "Out of Pocket Rehab Costs",
  isVisible: () => false,
  isEditable: () => true,
  isCurrency: true,
};

const legalFee = {
  id: "legalFee",
  label: "Legal Fee",
  isVisible: () => true,
  isEditable: () => false,
  isCurrency: false
};

const processingFee = {
  id: "processingFee",
  label: "Processing Fee",
  isVisible: () => true,
  isEditable: () => false,
  isCurrency: false
};

const originationPoints = {
  id: "originationPoints",
  label: "Origination Points",
  isVisible: () => true,
  isEditable: () => false,
  isCurrency: false
};

export const DSCRDefaultFeeDetailsDefault = [
  originationFee,
  estimatedClosingCosts,
  downPayment,
  taxesAndInsuranceReserves,
  closingFee,
  underWritingFee,
  totalEstimatedClosingCosts,
  appraisalFee,
  legalFee,
  processingFee,
  originationPoints
];

export const BridgeFeeDetails = [
  estimatedClosingCosts,
  downPayment,
  interestReserves,
  underWritingFee,
  originationFee,
  outOfPocketRehabCosts,
  closingFee,
  totalEstimatedClosingCosts
];   

const convertStringToCamelCase = (str: string) => {
return str
    .toLowerCase()
    .split('_')
    .map((word, index) => {
      if (index === 0) {
        return word; // Keep the first word lowercase
      }
      // Capitalize the first letter of subsequent words
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
};

function toTitleCaseWithSpaces(str: string) {
  return str
    // .toLowerCase() // Convert the string to lowercase
    .split('_') // Split by underscores
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words with spaces
}

export function convertStringToSnakeCase(str: string) {
   return str.toLowerCase().replace(/\s+/g, '_');
}

export const normalizeFeeDetailsConfig = (feeConfigs: any, type: any, userRole: string) => {
  const dscrConfig = feeConfigs?.termSheetDynamicFields?.filter((field: any) => field?.loanType === "30 Year Loan");
  const bridgeConfig = feeConfigs?.termSheetDynamicFields?.filter((field: any) => field?.loanType === "Bridge Loan");
  const nonEditableFields = userRole === 'loanOfficer' ? ["originationPoints"] : []

  switch (type) {
    case "InvestorDSCR":
      return dscrConfig?.map((field: any) => {
        const id = convertStringToCamelCase(field?.field);
        return {
          id,
          label: toTitleCaseWithSpaces(field?.field),
          isVisible: () => {return field?.isActive},
          // isVisible: () => true,
          isEditable: (key: any) => !nonEditableFields?.includes(key),
          isCurrency: field.dataType === "currency",
          defaultValue: field.defaultValue,
          dataType: field?.dataType,
          isActive: field?.isActive
        };
      });
      case "BridgeLoan":
        return bridgeConfig?.map((field: any) => {
          const id = convertStringToCamelCase(field?.field);
          return {
            id,
            label: toTitleCaseWithSpaces(field?.field),
            // isVisible: () => field?.isActive,
            isVisible: () => field?.isActive,
            isEditable: (key: any) => !nonEditableFields?.includes(key),
            isCurrency: field.dataType === "currency",
            defaultValue: field.defaultValue,
            dataType: field?.dataType,
            isActive: field?.isActive
          };
        });
        default:
          return [];
  }
}